var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("second-nav-bar"),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "table-container scroll" }, [
          _c("div", { staticStyle: { height: "250px" } }, [
            _c("div", { staticClass: "left-seal" }, [
              _c("p", { staticClass: "seal-title" }, [_vm._v("学校印章")]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "30px" } },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("电子章图片")]),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading[0],
                          expression: "loading[0]"
                        }
                      ],
                      staticClass: "avatar-uploader",
                      attrs: {
                        action: "/acc/school/seals",
                        accept: "image/png, image/jpeg",
                        data: { type: 1 },
                        headers: _vm.myHeaders,
                        "show-file-list": false,
                        "on-success": function(res, file) {
                          return _vm.handleAvatarSuccess(res, file, 0)
                        },
                        "before-upload": function(f) {
                          return _vm.beforeAvatarUpload(f, 0)
                        },
                        "on-error": function() {
                          return _vm.uploadError(0)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v(
                            "建议图片大小140*140，jpg、png格式，不超过500kb"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.fileUrl(1).t2
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: { src: _vm.fileUrl(1).t2 },
                            on: {
                              mouseenter: function($event) {
                                return _vm.hover(0)
                              },
                              mouseleave: function($event) {
                                return _vm.leave(0)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.fileUrl(1).t2 && _vm.mouseHover[0]
                        ? _c("div", { staticClass: "avatar select" }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#FFF",
                                  "font-size": "16px"
                                }
                              },
                              [_vm._v("修改")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#FFF",
                                  "font-size": "16px",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function(event) {
                                    return _vm.removeSeal(event, 1)
                                  }
                                }
                              },
                              [_vm._v("清除")]
                            )
                          ])
                        : !_vm.fileUrl(1).t2
                        ? _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right-seal" }, [
              _c("p", { staticClass: "seal-title" }, [_vm._v("校长印章")]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "30px" } },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("电子章图片")]),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading[1],
                          expression: "loading[1]"
                        }
                      ],
                      staticClass: "avatar-uploader",
                      attrs: {
                        action: "/acc/school/seals",
                        accept: "image/png, image/jpeg",
                        data: { type: 2 },
                        headers: _vm.myHeaders,
                        "show-file-list": false,
                        "on-success": function(res, file) {
                          return _vm.handleAvatarSuccess(res, file, 1)
                        },
                        "before-upload": function(f) {
                          return _vm.beforeAvatarUpload(f, 1)
                        },
                        "on-error": function() {
                          return _vm.uploadError(1)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v(
                            "建议图片大小140*140，jpg、png格式，不超过500kb"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.fileUrl(2).t2
                        ? _c("img", {
                            staticClass: "avatar",
                            style: _vm.imageUrl[1] ? "" : "opcacity: 0",
                            attrs: { src: _vm.fileUrl(2).t2 },
                            on: {
                              mouseenter: function($event) {
                                return _vm.hover(1)
                              },
                              mouseleave: function($event) {
                                return _vm.leave(1)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.fileUrl(2).t2 && _vm.mouseHover[1]
                        ? _c("div", { staticClass: "avatar select" }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#FFF",
                                  "font-size": "16px"
                                }
                              },
                              [_vm._v("修改")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#FFF",
                                  "font-size": "16px",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function(event) {
                                    return _vm.removeSeal(event, 2)
                                  }
                                }
                              },
                              [_vm._v("清除")]
                            )
                          ])
                        : !_vm.fileUrl(2).t2
                        ? _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "250px", "margin-top": "20px" } },
            [
              _c("div", { staticClass: "left-seal" }, [
                _c("p", { staticClass: "seal-title" }, [_vm._v("教导主任")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "30px" } },
                  [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("电子章图片")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading[2],
                            expression: "loading[2]"
                          }
                        ],
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "/acc/school/seals",
                          accept: "image/png, image/jpeg",
                          data: { type: 3 },
                          headers: _vm.myHeaders,
                          "show-file-list": false,
                          "on-success": function(res, file) {
                            return _vm.handleAvatarSuccess(res, file, 2)
                          },
                          "before-upload": function(f) {
                            return _vm.beforeAvatarUpload(f, 2)
                          },
                          "on-error": function() {
                            return _vm.uploadError(2)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "el-upload__tip",
                            attrs: { slot: "tip" },
                            slot: "tip"
                          },
                          [
                            _vm._v(
                              "建议图片大小140*140，jpg、png格式，不超过500kb"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.fileUrl(3).t2
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.fileUrl(3).t2 },
                              on: {
                                mouseenter: function($event) {
                                  return _vm.hover(2)
                                },
                                mouseleave: function($event) {
                                  return _vm.leave(2)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fileUrl(3).t2 && _vm.mouseHover[2]
                          ? _c("div", { staticClass: "avatar select" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#FFF",
                                    "font-size": "16px"
                                  }
                                },
                                [_vm._v("修改")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#FFF",
                                    "font-size": "16px",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function(event) {
                                      return _vm.removeSeal(event, 3)
                                    }
                                  }
                                },
                                [_vm._v("清除")]
                              )
                            ])
                          : !_vm.fileUrl(3).t2
                          ? _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon"
                            })
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right-seal" }, [
                _c("p", { staticClass: "seal-title" }, [_vm._v("德育主任")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "30px" } },
                  [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("电子章图片")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading[3],
                            expression: "loading[3]"
                          }
                        ],
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "/acc/school/seals",
                          accept: "image/png, image/jpeg",
                          data: { type: 4 },
                          headers: _vm.myHeaders,
                          "show-file-list": false,
                          "on-success": function(res, file) {
                            return _vm.handleAvatarSuccess(res, file, 3)
                          },
                          "before-upload": function(f) {
                            return _vm.beforeAvatarUpload(f, 3)
                          },
                          "on-error": function() {
                            return _vm.uploadError(3)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "el-upload__tip",
                            attrs: { slot: "tip" },
                            slot: "tip"
                          },
                          [
                            _vm._v(
                              "建议图片大小140*140，jpg、png格式，不超过500kb"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.fileUrl(4).t2
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.fileUrl(4).t2 },
                              on: {
                                mouseenter: function($event) {
                                  return _vm.hover(3)
                                },
                                mouseleave: function($event) {
                                  return _vm.leave(3)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fileUrl(4).t2 && _vm.mouseHover[3]
                          ? _c("div", { staticClass: "avatar select" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#FFF",
                                    "font-size": "16px"
                                  }
                                },
                                [_vm._v("修改")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#FFF",
                                    "font-size": "16px",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function(event) {
                                      return _vm.removeSeal(event, 4)
                                    }
                                  }
                                },
                                [_vm._v("清除")]
                              )
                            ])
                          : !_vm.fileUrl(4).t2
                          ? _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon"
                            })
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("校务管理 / 电子章管理")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-445b935f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-445b935f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/school-admin/affair/SealManage.vue
// module id = null
// module chunks = 